import { SubmitParams } from '..';
import { AttemptGetter } from '../getters';
import { getImage, drawImage } from '../utils';

import { BasicObject } from './basicObject';
import { getBasicButton } from './button';

export function getSubmitButton(
  getter: AttemptGetter,
  paintCanvas: () => void,
  submitAttempt: (submitParams: SubmitParams) => void,
  getThemeColor: () => string,
  eventSource: string,
  $canvas: JQuery<HTMLElement>,
  overrideDimension?: number
): BasicObject {
  const submitButton = getBasicButton($canvas);

  submitButton.gmmName = 'submit button';

  const buttonSize = overrideDimension ?? 40;

  submitButton.setAllDim(buttonSize, buttonSize);

  submitButton.mouseDownResponse = function () {
    if (getter) {
      if (getter.st === 'c') {
        submitButton.animated = false;

        return true;
      }

      getter.grabFocus();
    }

    submitAttempt({ eventSource });

    return true;
  };

  submitButton.paintMe = function (ctx) {
    subButtonPainting(
      ctx,
      0,
      0,
      paintCanvas,
      submitButton.animated,
      getThemeColor(),
      buttonSize,
      buttonSize,
      getter?.disabled || getter?.st === 'c'
    );
  };

  return submitButton;
}

export function subButtonPainting(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  onLoad: () => void,
  animated = false,
  animatedColor: string,
  sideW: number,
  sideH: number,
  disabled = false
): void {
  const w = sideW ?? 30;
  const h = sideH ?? 30;
  const r = 8;

  ctx.save();

  if (!disabled) {
    // Shadow settings (thin gray shadow on lower-right)
    ctx.shadowColor = 'darkgray';
    ctx.shadowBlur = 2;
    ctx.shadowOffsetX = 2;
    ctx.shadowOffsetY = 2;

    ctx.fillStyle = animated ? animatedColor : 'lightgray';
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'lightgray';
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();

    ctx.stroke();

    ctx.fill();
  }

  ctx.restore();

  const i = getImage(disabled ? 'checklight' : 'check', onLoad);

  drawImage(
    ctx,
    i,
    x + 0.15 * sideW,
    y + 0.15 * sideH,
    0.7 * sideW,
    0.7 * sideH
  );
}
